import { SvgIcon } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';

import { COLORS } from 'theme';

const SmartPhoneIcon = ({
  color = COLORS.kinetikBlack,
  size = '20px',
  sx = {},
  ...props
}) => (
  <SvgIcon
    viewBox="0 0 20 20"
    sx={{ width: size, height: size, ...sx }}
    {...props}
  >
    <path
      fill={color}
      d="M13.286 1.154c.864.116 1.575.364 2.138.926.562.563.809 1.274.925 2.137.112.836.112 1.902.112 3.237v5.093c0 1.335 0 2.401-.112 3.237-.116.864-.363 1.575-.925 2.138-.563.562-1.274.809-2.138.925-.835.112-1.901.112-3.236.112h-.094c-1.335 0-2.4 0-3.236-.112-.864-.116-1.575-.363-2.138-.925-.563-.563-.809-1.274-.925-2.138-.112-.836-.112-1.902-.112-3.237V7.454c0-1.335 0-2.401.112-3.237.116-.863.363-1.574.925-2.137.563-.562 1.274-.81 2.138-.926a.21.21 0 0 1 .233.18l.005.034.003.014.006.035c.075.452.14.845.232 1.16.1.337.249.655.535.91.297.262.638.373 1.003.423.345.048.77.049 1.266.049.495 0 .921-.001 1.266-.049.365-.05.706-.16 1.002-.424.287-.254.436-.572.536-.91.092-.314.157-.707.232-1.159l.006-.035.008-.05a.21.21 0 0 1 .233-.178ZM9.17 16.042a.625.625 0 0 0 0 1.25h1.666a.625.625 0 0 0 0-1.25H9.169Zm.88-15c.606 0 1.157 0 1.655.01a.111.111 0 0 1 .107.128c-.082.495-.136.812-.205 1.045-.063.216-.12.287-.165.327-.048.043-.125.09-.344.12-.241.033-.57.037-1.094.037-.524 0-.854-.004-1.095-.037-.22-.03-.296-.077-.345-.12-.044-.04-.1-.11-.165-.327-.068-.232-.121-.549-.204-1.042a.113.113 0 0 1 .11-.13c.497-.01 1.047-.011 1.652-.011h.093Z"
    />
  </SvgIcon>
);

SmartPhoneIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.string,
  sx: PropTypes.object,
};

export default SmartPhoneIcon;
